import { getAllEntities } from "./entities";
import { getArrayLabelMap } from '@/utils/tool'

export const amountOption = getAllEntities()?.amountsNewLables?.filter(item => item.value) || []
export const queueOption = [
  { label: '年龄', value: 1},
  { label: '风险评测资金量', value: 2},
]
export const compareOption = [
  { label: '大于等于', value: '>='},
  { label: '小于', value: '<'},
]

export const amountOptionMap = getArrayLabelMap(amountOption)
export const queueOptionMap = getArrayLabelMap(queueOption)
export const compareOptionMap = getArrayLabelMap(compareOption)